<script>
  export default {
    name: "404"
  }
</script>

<template>
  <div class="d-flex justify-content-center align-items-center">
    <div class="row text-center">
      <p class="fw-bolder opacity-75 text-warning m-0" style="font-size: 20rem;">404</p>
      <p class="h2 text-muted">Oops! Can't seem to find that resource!</p>
      <router-link class="btn btn-link" to="/">Head Home</router-link>
    </div>

  </div>
</template>

<style scoped>

</style>